import { ErrorMessage } from '@/modules/common/components/ErrorMessage';
import { useCurrentUser } from '@/modules/common/hooks/useUser';
import { UserInclude, UserRole } from '@/types/user';
import { Navigate, createFileRoute } from '@tanstack/react-router';

const RedirectComponent = () => {
  const { data: { data: user } = {}, isLoading } = useCurrentUser(
    [
      UserInclude.TaxBenefitProviders,
      UserInclude.EducationProvider,
      UserInclude.Company,
    ],
    {
      throwOnError: false,
    },
  );

  if (isLoading) return null;

  return user?.roles.includes(UserRole.EducationProvider) ? (
    <Navigate to="/courses" />
  ) : (
    <Navigate to="/applications" />
  );
};

export const Route = createFileRoute('/')({
  component: RedirectComponent,
  errorComponent: () => {
    return <ErrorMessage error={{ statusCode: 500 }} reset={() => null} />;
  },
});
